import app from 'flarum/forum/app';
import NotificationsDropdown, { INotificationsDropdown } from 'flarum/forum/components/NotificationsDropdown';
import ScheduledPostsList from './ScheduledPostsList';
import { slug } from '../../common';
import type ScheduledPostListState from '../states/ScheduledPostListState';

export interface IScheduledPostsDropdownAttrs extends INotificationsDropdown {
	state: ScheduledPostListState;
}

export default class ScheduledPostsDropdown<
	CustomAttrs extends IScheduledPostsDropdownAttrs = IScheduledPostsDropdownAttrs,
> extends NotificationsDropdown<CustomAttrs> {
	static initAttrs(attrs: IScheduledPostsDropdownAttrs) {
		attrs.label = attrs.label || app.translator.trans(`${slug}.forum.dropdown.tooltip`);
		attrs.icon = attrs.icon || 'fas fa-clock';

		super.initAttrs(attrs);
	}

	getMenu() {
		return (
			<div className={'Dropdown-menu ' + this.attrs.menuClassName} onclick={this.menuClick.bind(this)}>
				{this.showing ? <ScheduledPostsList state={this.attrs.state} /> : ''}
			</div>
		);
	}

	goToRoute() {
		m.route.set(app.route('scheduled_posts'));
	}

	getUnreadCount() {
		return app.session.user!.scheduledPostsCount();
	}

	getNewCount() {
		return this.getUnreadCount();
	}
}
